<h5 *ngIf="list && list.length > 0"><span *ngFor="let item of list" class="badge badge-secondary mr-1">{{item}} <span (click)="remove(item)" class="clickable ml-1">X</span></span></h5>
